import { render, staticRenderFns } from "./edit-duration.vue?vue&type=template&id=0ba42658&"
import script from "./edit-duration.vue?vue&type=script&lang=js&"
export * from "./edit-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports